import { createMocks } from '@backbase/foundation-ang/data-http';
import { Provider } from '@angular/core';

/**
 * Mocks provider for /catalogue-service/v2/catalogue URL pattern
 */
export const CataloguesHttpServiceGetCatalogByIdMocksProvider: Provider = createMocks([
  {
    urlPattern: '/catalogue-service/v2/catalogue',
    method: 'GET',
    responses: [],
  },
]);

export const CataloguesHttpServiceMocksProvider: Provider = createMocks([
  {
    urlPattern: '/catalogue-integration-service/v2/catalogue',
    method: 'GET',
    responses: [
      {
        status: 200,
        body: [
          { id: '01', desc: 'Banesco' },
          { id: '02', desc: 'Otros Bancos' },
          { id: '03', desc: 'Regional / Internacional' },
        ],
      },
    ],
  },
]);
export const CataloguesByGroupIdHttpServiceMocksProvider: Provider = createMocks([
  {
    urlPattern: '/catalogue-integration-service/v2/catalogueByGroup',
    method: 'GET',
    responses: [
      {
        status: 200,
        body: [
          { id: '01', desc: 'Banesco' },
          { id: '02', desc: 'Otros Bancos' },
          { id: '03', desc: 'Regional / Internacional' },
        ],
      },
    ],
  },
]);
